<template>
  <div class="">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  name: 'CreateQrCode',
  props: {
    url: String
  },
  data() {
    return {}
  },
  // watch: {
  //   url(val) {
  //     if (val) {

  //     }
  //   }
  // },
  created() { },
  mounted() { },
  methods: {
    init(str) {
      const canvas = this.$refs.canvas
      QRCode.toCanvas(canvas, str, (error) => {
        if (error) console.error(error)
        console.log('success!')
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
